// OAuth parameters and navigation cache keys must not survive a payment round trip.
export const paymentReturnPath = (path, marketId) => {
  let candidate = typeof path === 'string' ? path : '/myOrder'
  if (!candidate.startsWith('/') || candidate.startsWith('//') || candidate.includes('\\')) candidate = '/myOrder'
  let url
  try {
    url = new URL(candidate, window.location.origin)
    if (url.origin !== window.location.origin || url.pathname.startsWith('/fuxunPayResult')) {
      url = new URL('/myOrder', window.location.origin)
    }
  } catch (error) { url = new URL('/myOrder', window.location.origin) }
  for (const key of ['code', 'state', 'VNK']) url.searchParams.delete(key)
  if (url.hash === '#wechat_redirect') url.hash = ''
  if (marketId) url.searchParams.set('marketId', String(marketId))
  return url.pathname + url.search + url.hash
}

// vue-navigation 1.x wraps replace without returning Vue Router's Promise.
export const replacePaymentRoute = (router, location, freshCache = true) => new Promise((resolve, reject) => {
  const route = router.resolve(location).route
  const query = { ...route.query }
  // Supply the key before navigation so the plugin does not redirect/abort this transition.
  if (freshCache || !query.VNK) query.VNK = Date.now().toString(36) + Math.random().toString(36).slice(2, 8)
  router.replace({ path: route.path, query, hash: route.hash }, resolve, error => {
    if (error && error.name === 'NavigationDuplicated') resolve(router.currentRoute)
    else reject(error)
  })
})
